
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  display: block;
}

.idb-section-wrapper {
  padding-top: 3rem;
  padding-bottom: 3rem;
  color: var(--blue-responsible-darken-2);
}

.section-header {
  padding-left: 6rem;
  padding-right: 6rem;
  padding-bottom: 4rem;
  text-align: center;
}

idb-heading {
  margin-top: 2rem;
}

idb-heading:first-of-type {
  margin-top: 0px;
}

.cta-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 6rem;
}

.section-background--blue {
  background-color: var(--blue-responsible-lighten-4);
}

.section-background--light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

.section-background--gray-dark {
  background-color: var(--idblab-gray-dark);
}

.section-background--light-gray {
  background-color: var(--idblab-gray-light);
}

.section-background--gray {
  background-color: var(--gray-professional-lighten-4);
}

.section-background--green {
  background-color: var(--green-guarantee-lighten-4);
}

.section-background--idblab-light-blue {
  background-color: var(--idblab-blue-lighten-2);
}

.section-background--idblab-blue {
  background-color: var(--idblab-blue-darken-1);
}

.section-background--idblab-green {
  background-color: var(--idblab-green-darken-1);
}

.section-background--black {
  background-color: var(--outline-black);
}

.section-background--light-gray, .section-background--gray-light {
  background-color: var(--idblab-gray-light);
}

.section-background--sm-yellow-wave, .section-background--md-yellow-wave, .section-background--lg-yellow-wave, .section-background--sm-green-wave, .section-background--md-green-wave, .section-background--lg-green-wave, .section-background--sm-blue-wave, .section-background--md-blue-wave, .section-background--lg-blue-wave {
  background-image: none;
  background-position: center;
  background-repeat: no-repeat;
}

@media (min-width: 1024px){

.section-background--sm-yellow-wave, .section-background--md-yellow-wave, .section-background--lg-yellow-wave, .section-background--sm-green-wave, .section-background--md-green-wave, .section-background--lg-green-wave, .section-background--sm-blue-wave, .section-background--md-blue-wave, .section-background--lg-blue-wave {
    background-size:cover;
    background-position-y:70%;
  }
  }

@media (min-width: 1024px){

.section-background--sm-yellow-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1462 530' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%23F5CA50'/%3E%3Cpath d='M2 510c181.5-71 384-62.5 574-62.5 261 0 455 62.5 881.5-170' stroke='%23FE5100' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M2 510c181.5-71 384-62.5 574-62.5 261 0 455 62.5 881.5-170' stroke='%23000' stroke-opacity='.3' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--md-yellow-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1472 704' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1470 189s-149.2-20.5-402-20.5C836.5 168.5 589.4-2.7 335 0 148.4 2 30 34.6 30 34.6V661s516-82.5 798-89c281-6.5 642 78.5 642 78.5V189Z' fill='%23F5CA50'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%23FE5100' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%23000' stroke-opacity='.3' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--lg-yellow-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1440 1188' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1440 90.556s-88.7 133.5-341.5 133.5c-231.5 0-539.126-228.148-793.5-224C118.416 3.099 0 51.865 0 51.865V1187.56s437.99-55.23 720-64.93c281.09-9.67 720 15.15 720 15.15V90.556Z' fill='%23F5CA50'/%3E%3Cpath d='M-15 592.899c67.547 94.441 284.004 263.785 609.455 185.626C1001.27 680.827 1225.86 454.167 1453 523.533' stroke='%23FE5100' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M-15 592.899c67.547 94.441 284.004 263.785 609.455 185.626C1001.27 680.827 1225.86 454.167 1453 523.533' stroke='%23000' stroke-opacity='.3' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--sm-green-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1462 530' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%23308144'/%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 510c181.5-71 384-62.5 574-62.5 261 0 455 62.5 881.5-170' stroke='%23A6C964' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--md-green-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1472 704' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1470 189s-149.2-20.5-402-20.5C836.5 168.5 589.4-2.7 335 0 148.4 2 30 34.6 30 34.6V661s516-82.5 798-89c281-6.5 642 78.5 642 78.5V189Z' fill='%23308144'/%3E%3Cpath d='M1470 189s-149.2-20.5-402-20.5C836.5 168.5 589.4-2.7 335 0 148.4 2 30 34.6 30 34.6V661s516-82.5 798-89c281-6.5 642 78.5 642 78.5V189Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%234BA6DE' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%23fff' stroke-opacity='.6' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--lg-green-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1440 1175' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 118.5S96.7 179 349.5 179C581 179 784.1-3.3 1038.5.5 1225.1 3.3 1440 107 1440 107v1068s-438-51-720-60c-281-9-720 14-720 14V118.5Z' fill='%23308144'/%3E%3Cpath d='M0 118.5S96.7 179 349.5 179C581 179 784.1-3.3 1038.5.5 1225.1 3.3 1440 107 1440 107v1068s-438-51-720-60c-281-9-720 14-720 14V118.5Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M0 69c66.2 48.3 278.2 135 597 95 398.5-50 618.5-166 841-130.5' stroke='%23FE5100' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M0 69c66.2 48.3 278.2 135 597 95 398.5-50 618.5-166 841-130.5' stroke='%23000' stroke-opacity='.4' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

.section-background--sm-blue-wave{
  background-image:none;
}

@media (min-width: 1024px){

.section-background--sm-blue-wave{
    background-size:100%;
    background-repeat:no-repeat;
    background-position:center center;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1462 530' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%234BA6DE'/%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 510c181.5-71 384-62.5 574-62.5 261 0 455 62.5 881.5-170' stroke='%23F6E375' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

.section-background--sm-blue-wave-bottom{
  background-image:none;
}

@media (min-width: 1024px){

.section-background--sm-blue-wave-bottom{
    background-size:100%;
    background-repeat:no-repeat;
    background-position:bottom center;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1462 530' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%234BA6DE'/%3E%3Cpath d='M22 516.5s167.2-40 420-40c231.5 0 322.2 7.8 574.5 40 231.5 29.5 445.5 0 445.5 0V0s-143 223.9-425 228.3c-281 4.4-1015-59-1015-59v347.2Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 510c181.5-71 384-62.5 574-62.5 261 0 455 62.5 881.5-170' stroke='%23F6E375' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--md-blue-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1472 704' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1470 189s-149.2-20.5-402-20.5C836.5 168.5 589.4-2.7 335 0 148.4 2 30 34.6 30 34.6V661s516-82.5 798-89c281-6.4 642 78.5 642 78.5V189Z' fill='%234BA6DE'/%3E%3Cpath d='M1470 189s-149.2-20.5-402-20.5C836.5 168.5 589.4-2.7 335 0 148.4 2 30 34.6 30 34.6V661s516-82.5 798-89c281-6.4 642 78.5 642 78.5V189Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%234BA6DE' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M2 496.3C69.5 590.8 286 760.1 611.5 682c406.8-97.7 631.4-324.4 858.5-255' stroke='%23fff' stroke-opacity='.6' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }

@media (min-width: 1024px){

.section-background--lg-blue-wave{
    background-size:cover;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 1472 1188' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1457 90.6S1368.3 224 1115.5 224C884 224 576.4-4.1 322 0 135.4 3 17 51.9 17 51.9v1135.7s438-55.3 720-65c281-9.6 720 15.2 720 15.2V90.6Z' fill='%234BA6DE'/%3E%3Cpath d='M1457 90.6S1368.3 224 1115.5 224C884 224 576.4-4.1 322 0 135.4 3 17 51.9 17 51.9v1135.7s438-55.3 720-65c281-9.6 720 15.2 720 15.2V90.6Z' fill='%23fff' fill-opacity='.2'/%3E%3Cpath d='M2 592.9c67.5 94.4 284 263.8 609.5 185.6 406.8-97.7 631.4-324.3 858.5-255' stroke='%23F4DB4E' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M2 592.9c67.5 94.4 284 263.8 609.5 185.6 406.8-97.7 631.4-324.3 858.5-255' stroke='%23fff' stroke-opacity='.2' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E%0A")
}
  }
`;